/**
 * Generates a unique message ID by combining timestamp and random number
 * @param prefix - Optional prefix for the message ID (e.g., 'user', 'assistant', 'error')
 * @param backendId - Optional backend-provided ID to use instead of generating one
 * @returns A unique message ID string
 */
export const generateMessageId = (prefix?: string, backendId?: string): string => {
  // If backend provides an ID, use it (guaranteed unique from database)
  if (backendId) {
    return backendId;
  }

  // Generate a 6-digit random number (100000-999999)
  const randomSuffix = Math.floor(Math.random() * 900000) + 100000;
  
  // Combine timestamp with random number for uniqueness
  const uniqueId = `${Date.now()}-${randomSuffix}`;
  
  // Return with prefix if provided
  return prefix ? `${prefix}-${uniqueId}` : uniqueId;
};

